import {
  type CommerceSelectOptionViewModel,
  type EligibilityFormState,
  type EligibilityPolicy,
  lookupOptionLabel,
  buildEligibilityPolicyTargetLabel,
} from '@/lib/commerce';
import { cn } from '@/lib/utils';

export function StorefrontPolicySentence({
  form,
  lookups,
}: {
  form: EligibilityFormState;
  lookups: {
    product: Map<string, CommerceSelectOptionViewModel>;
    variant: Map<string, CommerceSelectOptionViewModel>;
    serviceClass: Map<string, CommerceSelectOptionViewModel>;
    serviceGroup: Map<string, CommerceSelectOptionViewModel>;
    market: Map<string, CommerceSelectOptionViewModel>;
    segment: Map<string, CommerceSelectOptionViewModel>;
    tenant: Map<string, CommerceSelectOptionViewModel>;
    store: Map<string, CommerceSelectOptionViewModel>;
    agent: Map<string, CommerceSelectOptionViewModel>;
    publication: Map<string, CommerceSelectOptionViewModel>;
  };
}) {
  const targetLabel = buildEligibilityPolicyTargetLabel(
    {
      policy_id: '',
      catalog_owner_tenant_id: '',
      subject_type: form.subjectType,
      subject_id: form.subjectId,
      subject_key: form.subjectKey,
      publication_id: form.publicationId,
      publication_label: lookupOptionLabel(lookups.publication, form.publicationId),
      action: form.action,
      requires_can_sign_up: form.requiresCanSignUp,
      requires_can_schedule_install: form.requiresCanScheduleInstall,
      priority: parseInt(form.priority || '100', 10) || 100,
      created_at: '',
      updated_at: '',
    },
    lookups,
  );

  const scopeParts: string[] = [];
  if (form.marketId) scopeParts.push(`in ${lookupOptionLabel(lookups.market, form.marketId) || form.marketId}`);
  if (form.segmentId) scopeParts.push(`in ${lookupOptionLabel(lookups.segment, form.segmentId) || form.segmentId}`);
  if (form.sellingTenantId) scopeParts.push(`for ${lookupOptionLabel(lookups.tenant, form.sellingTenantId) || form.sellingTenantId}`);
  if (form.storeId) scopeParts.push(`at ${lookupOptionLabel(lookups.store, form.storeId) || form.storeId}`);
  if (form.agentUserId) scopeParts.push(`by ${lookupOptionLabel(lookups.agent, form.agentUserId) || form.agentUserId}`);

  return (
    <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 text-xs font-bold leading-relaxed text-foreground shadow-sm">
      This policy will{' '}
      <span
        className={cn(
          'rounded px-1.5 py-0.5 text-[10px] uppercase tracking-tighter text-white',
          form.action === 'allow' ? 'bg-emerald-600' : 'bg-rose-600',
        )}
      >
        {form.action.toUpperCase()}
      </span>{' '}
      <span className="text-primary">{targetLabel}</span>{' '}
      {scopeParts.length > 0 ? scopeParts.join(' and ') : 'everywhere in this storefront publication'}.
    </div>
  );
}
